import React, { useContext, useState } from 'react';

// Styles and assets
import styles from './PatientsToolbar.module.css';
import { MdEdit, MdHistory } from 'react-icons/md';
import { RiFilterFill } from 'react-icons/ri';
import { IoPersonAddOutline } from 'react-icons/io5';

// Context
import FiltersContext from '../../../context/FiltersContext';
import GeneralContext from '../../../context/GeneralContext';

// Hooks
import useFilteredPatients from '../../../hooks/useFilteredPatients';

// Components
import Toolbar from '../../UI/Toolbar/Toolbar';
import ButtonToolbar from '../../UI/ButtonToolbar/ButtonToolbar';
import FilterDialog from '../../PatientsPage/FilterDialog/FilterDialog';
import EditColumnsDialog from '../../PatientsPage/EditColumnsDialog/EditColumnsDialog';
import Searchbar from '../../UI/Searchbar/Searchbar';
import SliderCheckbox from '../../UI/SliderCheckbox/SliderCheckbox';
import AddPatientByCipDialog from '../../PatientsPage/AddPatientByCipDialog/AddPatientByCipDialog';

// Language
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const PatientsToolbar: React.FC = () => {
    const { t } = useTranslation();

    const { patientFilters } = useContext(FiltersContext);
    const generalContext = useContext(GeneralContext);

    const [showAddPatientDialog, setShowAddPatientDialog] = useState(false);

    const handleViewChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        generalContext.setViewSonar(evt.target.checked);
    };

    const { numFilteredPatients, filtersActive, handleChangeSearchbar } =
        useFilteredPatients();

    return (
        <>
            <Toolbar>
                <div className={styles.patientsToolbarContainer}>
                    <div className={styles.columnsToolbar}>
                        <SliderCheckbox
                            checked={generalContext.viewSonar}
                            handleChange={handleViewChange}
                            label={t('sonar_view')}
                        />
                    </div>

                    <div className={styles.columnsToolbar}>
                        <Searchbar
                            handleChange={handleChangeSearchbar}
                            defaultValue={patientFilters.currentSearchbarText}
                        />

                        <ButtonToolbar
                            icon={<RiFilterFill />}
                            label={t('filter') + ' ' + numFilteredPatients}
                            defaultFilterActive={filtersActive}
                        >
                            <FilterDialog
                                modalShow={() => undefined}
                                setFilterBallActive={() => undefined}
                            />
                        </ButtonToolbar>

                        <ButtonToolbar
                            icon={<MdEdit />}
                            label={t('custom_columns')}
                        >
                            <EditColumnsDialog
                                modalShow={() => undefined}
                                sonarView={generalContext.viewSonar}
                            />
                        </ButtonToolbar>

                        <div className={styles.rightButtons}>
                            <Link
                                to="/home/patients/cases"
                                className={`button ${styles.buttonCases}`}
                                style={{ textDecoration: 'none' }}
                            >
                                <span>{t('cases_history')}</span>
                                <MdHistory />
                            </Link>

                            <button
                                type="button"
                                className={`button ${styles.buttonAddPatient}`}
                                onClick={() => setShowAddPatientDialog(true)}
                            >
                                <span>{t('add_patient')}</span>
                                <IoPersonAddOutline />
                            </button>
                        </div>
                    </div>
                </div>
            </Toolbar>

            {showAddPatientDialog && (
                <AddPatientByCipDialog
                    closeModal={() => setShowAddPatientDialog(false)}
                />
            )}
        </>
    );
};

export default PatientsToolbar;